import React from "react";

import { CompanyCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function company({ width, onResize }: Column.Options) {
	return base(ColumnId.Company, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default company;
